import React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import FavoriteIcon from '@mui/icons-material/Favorite';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import './style/SliderBottomModal.css';

function SliderBottomModal({ isOpen, onClose, product }) {
    if (!isOpen) return null;

    return (
        <div className="slider-bottom-modal-overlay" onClick={onClose}>
            <div className="slider-bottom-modal" onClick={e => e.stopPropagation()}>
                <div className="slider-bottom-modal-header">
                    <div className="slider-bottom-modal-jump">
                        <span className="slider-bottom-modal-jump-1"><a href="/">Главная</a></span>
                        <span className="slider-bottom-modal-jump-4">&bull;</span>
                        <span className="slider-bottom-modal-jump-2"><a href="/">Молочное</a></span>
                        <span className="slider-bottom-modal-jump-4">&bull;</span>
                        <span className="slider-bottom-modal-jump-3"><a href="/">Молоко</a></span>
                    </div>
                    <button onClick={onClose} className="slider-bottom-modal-close-button"><CloseIcon /></button>
                </div>
                <div className="slider-bottom-modal-content">
                    <div className="slider-bottom-modal-images">
                        <div className="slider-bottom-modal-thumbnail"></div>
                        <div className="slider-bottom-modal-thumbnail"></div>
                        <div className="slider-bottom-modal-thumbnail"></div>
                        <div className="slider-bottom-modal-thumbnail"></div>
                        <div className="slider-bottom-modal-main-image"></div>
                    </div>
                    <div className="slider-bottom-modal-info">
                        <h2>{product.name}</h2>
                        <p>Пищевая ценность на 100г:</p>
                        <p>Белки: 3.0 г, Жиры: 2.5 г, Углеводы: 4.7 г, Калорийность: 53.0 ккал</p>
                        <p>Цена: {product.price} ₽</p>
                        <button className="slider-bottom-modal-cart-button"><ShoppingCartIcon /> В корзину</button>
                        <button className="slider-bottom-modal-favorite-button"><FavoriteIcon /></button>
                    </div>
                </div>
                <div className="slider-bottom-modal-description">
                    <h2>Описание</h2>
                    <p>{product.description}</p>
                </div>
            </div>
        </div>
    );
}

export default SliderBottomModal;
